import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import CustomRadio from "../../customRadio";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.css";
import {
  vehicle_inspection_car,
  vehicle_inspection_img,
  // star,
} from "../../../assets/images";
import axiosInstance from "../../../services/axios.instance";
import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "../../../services/events";
import { API_URL } from "../../../services/apiConfig";
import RentalSummarySecondPage from "../RentalSummarySecondPage";
import { useSelector, useDispatch } from "react-redux";
import { setBookingValues } from "../../../Redux/BookingData/bookingDataSlice";
interface bookingData {
  product_id: string;
  base_product_id: string;
  product_name: string;
  product_description: string;
  merchant_id: string;
  quantity: number;
  item_id: string;
  promotion_id: string;
  price: number;
  price_per_month: number;
  price_per_week: number;
  toppings: any[];
  buy_more_pay_less: object;
  discount_event: object;
  variant: object;
  shop_id: string;
  product_details: string;
}

const VehicleInspection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [deliveryFee, setDeliveryFee] = useState<number>(0);
  const [returnOption, setReturnOption] = useState<string>("collect");
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [availableMerchants, setAvailableMerchants] = useState<any[]>([]);
  const [selectedMerchantId, setSelectedMerchantId] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });

  const [bookingPayload, setBookingPayload] = useState<bookingData>({
    product_id: "",
    base_product_id: "",
    product_name: "",
    product_description: "",
    merchant_id: "",
    quantity: 1,
    item_id: "",
    promotion_id: "",
    price: 0,
    price_per_week: 0,
    price_per_month: 0,
    toppings: [],
    buy_more_pay_less: {},
    discount_event: {},
    variant: {},
    shop_id: "",
    product_details: "",
  });

  useEffect(() => {
    if (!location.state) {
      navigate("/customer/myaccount", { replace: true });
      return;
    }
  }, [location.state, navigate]);

  useEffect(() => {
    const trackPageLoad = async () => {
      await trackEvent({
        event_name: {
          web: "Kirkos_VehicleInspectionConfirmScreen",
          app: "Kirkos_VehicleInspectionConfirmScreen_App",
        },
        event_category: "VehicleInspection_Info",
        module: "VehicleInspection",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  const locationState = location.state || {};
  const {
    deliveryDetails,
    optionalData,
    selectedItem,
    merchantId,
    searchData,
    additionalDriverFee,
    cdw_Amount,
    scdw_Amount,
    babySeatAmount,
    pai_InsuranceAmount,
  } = locationState;

  const rentalTotalVat: number = selectedItem?.product_details_car?.totalVat ?? 0;
  const rentalTotalStripeFeeFinal: number = selectedItem?.product_details_car?.totalStripeFeeFinal ?? 0;
  // const [selectedOptions, setSelectedOptions] = useState<string>("");
  const { bookingValues } = useSelector((state: any) => state.bookingValues);
  const [merchantId1, setMerchantId1] = useState<string>("");
  const [isAirportPickup, setIsAirportPickup] = useState<boolean>(false);
  const [showAirportOptions, setShowAirportOptions] = useState<boolean>(false);
  const [isDriverPickupInAirport, setIsDriverPickupInAirport] =
    useState<boolean>(false);
  const [showAirportError, setShowAirportError] = useState<boolean>(false);
  const [deliveryOptionError, setDeliveryOptionError] = useState<string>("");
  const [nearestBranchError, setNearestBranchError] = useState<string>("");
  const errorSectionRef = useRef<HTMLDivElement | null>(null);

  const accessToken = localStorage.getItem("access_token");

  // const decodeToken = (token: any) => {
  //   return JSON.parse(atob(token.split(".")[1]));
  // };
  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  //const customerId = decodedToken["customer-id"];
  const customerId =
    decodedToken && decodedToken["customer-id"]
      ? decodedToken["customer-id"]
      : null;

  // const handleRadioChange = (value: string) => {
  //   // setSelectedOptions(value);
  //   // Dispatch action to update booking values in Redux
  //   // dispatch(setBookingValues({ selectedOptions: value }));
  //   dispatch(setBookingValues({ ...bookingValues, deliveryAmount: value }));
  // };

  //---------------------------------------------------------------------------------------
  useEffect(() => {
    if (searchData?.pickupLocLatitude && searchData?.pickupLocLongitude) {
      getNearestMerchant.mutate({
        latitude: searchData.pickupLocLatitude,
        longitude: searchData.pickupLocLongitude,
      });
    }
  }, [searchData]);

  useEffect(() => {
    const getCartData = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_URL.GET_CART}/${customerId}/carts`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const merchantKey = Object.keys(response.data)[0];
        setMerchantId1(merchantKey);

        // console.log("Cart data:", response.data);
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    if (customerId) {
      getCartData();
    }
  }, [customerId]);

  useEffect(() => {
    if (bookingValues?.deliveryAmount === "No") {
      setIsButtonDisabled(false);
      mutation.mutate();
    } else if (
      bookingValues?.deliveryAmount === "Yes" &&
      availableMerchants.length > 0
    ) {
      setIsButtonDisabled(!selectedMerchantId);
    } else if (bookingValues?.deliveryAmount === "Yes") {
      getNearestMerchant.mutate({
        latitude: searchData?.pickupLocLatitude,
        longitude: searchData?.pickupLocLongitude,
      });
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(true);
    }
  }, [
    bookingValues?.deliveryAmount,
    selectedMerchantId,
    availableMerchants.length,
  ]);

  const getNearestMerchant = useMutation({
    mutationFn: (data: { latitude: string; longitude: string }) =>
      axiosInstance.post(
        `${API_URL.GET_NEAREST_MERCHANT}?productId=${selectedItem?.product_id}&merchantId=${merchantId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      ),
    onSuccess: (response) => {
      // console.log("Nearest merchant response:", response.data);
      setAvailableMerchants(response.data.available_merchants || []);
    },
    onError: (error) => {
      console.error("Error fetching nearest merchant:", error);
    },
  });

  const handleMerchantSelection = (selectedId: string) => {
    setDeliveryFee(0);
    setSelectedMerchantId(selectedId);
    if (selectedId) {
      setNearestBranchError("");
    }

    const selectedMerchant = availableMerchants.find(
      (merchant) => merchant.merchant_id === selectedId,
    );

    if (selectedMerchant) {
      const updatedPayload: bookingData = {
        product_id: selectedMerchant.product_id,
        base_product_id: selectedMerchant.product_id,
        product_name: selectedMerchant.product_name,
        product_description:
          selectedMerchant.product_details?.description || "",
        merchant_id: selectedMerchant.merchant_id,
        quantity: 1,
        item_id: "",
        promotion_id: "",
        price:
          selectedMerchant.inventories?.[
            Object.keys(selectedMerchant.inventories)[0]
          ]?.price || 0,
        price_per_month: selectedItem?.product_details_car?.price_per_month,
        price_per_week: selectedItem?.product_details_car?.price_per_week,
        toppings: [],
        buy_more_pay_less: {},
        discount_event: {},
        variant: {},
        shop_id: selectedMerchant.vendor_IDs?.[0] || "",
        product_details: selectedMerchant.product_details?.description || "",
      };

      handleClear.mutate();
      setBookingPayload(updatedPayload);
    }
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (isDropdownOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isDropdownOpen]);

  const handleMerchantChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleMerchantSelection(e.target.value);
  };

  const handleClear = useMutation({
    mutationFn: () =>
      axiosInstance.get(
        `${API_URL.CLEAR_CART}/${customerId}/carts/${merchantId1 || merchantId
        }/clear`,
      ),
    onSuccess: (successResponse) => {
      // console.log("Clear cart success:", JSON.stringify(successResponse));
      handleBooking.mutate(bookingPayload);
    },
    onError: (error: any) => {
      console.error("Clear cart error:", error);
    },
  });

  const handleBooking = useMutation({
    mutationFn: (userData: bookingData) =>
      axiosInstance.post(
        `${API_URL.BOOKING_NOW}/${customerId}/carts`,
        userData,
      ),
    onSuccess: (successResponse) => {
      console.log("Booking success:");
    },
    onError: (error) => {
      console.error("Booking error:", error);
    },
  });
  const getAdditionalOptions = useMutation({
    mutationFn: () =>
      axiosInstance.get(`${API_URL.ADDITIONAL_OPTIONS}/${merchantId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      }),
    onSuccess: (response) => {
      if (response?.data?.isAirport) {
        setShowAirportOptions(true);
        setIsDriverPickupInAirport(
          response?.data?.isDriverPickupInAirport !== false,
        );
      }
      if (response?.data?.isDriverPickupInAirport === false) {
        setShowAirportError(true);
      }
    },
    onError: (error) => {
      console.error("Error fetching additional options:", error);
    },
  });

  useEffect(() => {
    getAdditionalOptions.mutate();
  }, []);

  const handleAirportPickupChange = (value: string) => {
    const isAirport = value === "Yes";
    setIsAirportPickup(isAirport);
    dispatch(
      setBookingValues({
        ...bookingValues,
        isAirport: isAirport,
        airportFee: isAirport && isDriverPickupInAirport ? 50 : 0,
      }),
    );
  };
  const handleRadioChange = (value: string) => {
    setDeliveryOptionError("");
    if (value === "No") {
      setNearestBranchError("");
    }
    dispatch(
      setBookingValues({
        ...bookingValues,
        deliveryAmount: value,
        isAirport: false,
        airportFee: 0,
      }),
    );

    if (value === "No") {
      setIsButtonDisabled(false); // Enable button immediately for "No" selection
      setReturnOption("collect"); // Reset to default: Collect from me
      mutation.mutate();
      const updatedPayload: bookingData = {
        product_id: selectedItem?.product_id,
        base_product_id: selectedItem?.product_id,
        product_name: selectedItem?.product_name,
        price_per_month: selectedItem?.product_details_car?.price_per_month,
        price_per_week: selectedItem?.product_details_car?.price_per_week,
        product_description: selectedItem?.product_details?.description || "",
        merchant_id: merchantId,
        quantity: 1,
        item_id: "",
        promotion_id: "",
        price: selectedItem?.vendor_product_inventories[0]?.price,
        toppings: [],
        buy_more_pay_less: {},
        discount_event: {},
        variant: {},
        shop_id: selectedItem?.vendor_product_inventories[0]?.vendor_id,
        product_details: selectedItem?.product_details?.description,
      };
      setBookingPayload(updatedPayload);
      handleClear.mutate();
    } else {
      setIsButtonDisabled(true);
    }
  };

  // const businessArea = decodedToken["planet"];

  //-----------------------
  const mutation = useMutation({
    mutationFn: () =>
      axiosInstance.get(`${API_URL.DELIVERY_FEE}/${merchantId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          location: `0,0`,
        },
      }),

    onSuccess: (successResponse) => {
      // console.log("successResponseproductlist", successResponse);
      const charge = successResponse?.data?.deliveryCharge || 0;
      // Fee is set based on returnOption; if not yet selected, default to delivery only
      if (returnOption === "collect") {
        setDeliveryFee(charge + charge); // delivery + recollection
      } else {
        setDeliveryFee(charge); // delivery only (drop off by myself)
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        //alert(error?.data?.message);
      }
    },
  });

  //------------------------------------------------------------------------------------

  // const cdwDailyRate =
  //   selectedItem?.product_details_car?.collision_damage_waiver_model
  //     ?.daily_collision_damage_waiver;
  //

  // let cdwAmount = 0;
  // if (cdwDailyRate !== undefined && daysDifference !== undefined) {
  //   cdwAmount = cdwDailyRate * daysDifference;
  // }

  // const scdwDailyRate =
  //   selectedItem?.product_details_car?.super_collision_damage_waiver_model
  //     ?.daily_super_collision_damage_waiver;

  // let scdwAmount = 0;
  // if (scdwDailyRate !== undefined && daysDifference !== undefined) {
  //   scdwAmount = scdwDailyRate * daysDifference;
  // }
  const daysDifference = deliveryDetails?.daysDifference;
  const wtpDailyRate =
    selectedItem?.product_details_car?.wind_shield_protection;
  let wtpAmount = 0;
  if (wtpDailyRate !== undefined && daysDifference !== undefined) {
    wtpAmount = wtpDailyRate * daysDifference;
  }

  const handleBack = () => {
    navigate("/customer/unified-booking", {
      state: location.state
    });
  };

  const handleConfirmation = async () => {
    if (!selectedItem || !merchantId || !searchData) {
      navigate("/customer/myaccount", { replace: true });
      return;
    }

    let hasError = false;

    if (!bookingValues?.deliveryAmount) {
      setDeliveryOptionError("Please select any preferred option");
      hasError = true;
    } else {
      setDeliveryOptionError("");
    }

    if (bookingValues?.deliveryAmount === "Yes" && !selectedMerchantId) {
      setNearestBranchError("Please select the nearest branch option");
      hasError = true;
    } else if (bookingValues?.deliveryAmount === "Yes") {
      setNearestBranchError("");
    }


    if (hasError) {
      if (errorSectionRef.current) {
        errorSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      return;
    }

    const deliveredBy =
      bookingValues?.deliveryAmount === "Yes" ? "CUSTOMER" : "KIRKOS_EXECUTIVE";

    const deliveryData = {
      deliveredBy,
    };

    await trackEvent({
      event_name: {
        web: "Kirkos_VehicleInspectionConfirmButton_Success",
        app: "Kirkos_VehicleInspectionConfirmButton_Success_App",
      },
      event_category: "VehicleInspection_Info",
      module: "VehicleInspection",
      payload: {
        status: "success",
        delivered_by: deliveredBy,
        delivery_amount: bookingValues?.deliveryAmount,
      },
    });

    navigate("/customer/processpayment", {
      state: {
        deliveryData,
        deliveryDetails,
        optionalData,
        selectedItem,
        merchantId,
        deliveryFee,
        searchData,
        additionalDriverFee,
        cdw_Amount,
        scdw_Amount,
        babySeatAmount,

        wtpAmount,
        pai_InsuranceAmount,
      },
    });
  };

  if (!location.state || !selectedItem || !merchantId || !searchData) {
    return null;
  }

  return (
    <div className="row g-4 vehicle-inspection-container">
      <div className="col-lg-8 vehicle-inspection-form-section">
        <div className="card card-custom">
          <div className="card-body">
            {/* Page Title */}
            <div className="d-flex align-items-center gap-3 mb-5">
              <img src={vehicle_inspection_car} alt="" className="header-icon" />
              <h1 className="page-head-add mb-0">Vehicle pickup and drop off preferences</h1>
            </div>

            {/* Delivery Section */}
            <div className="mb-5" ref={errorSectionRef}>
              <div className="d-flex align-items-center gap-2 mb-4">
                <div className="section-header-bar"></div>
                <h2 className="page-head-add fs-5 mb-0">How would you prefer to receive the car?</h2>
              </div>

              <div className="options-grid">
                <div
                  className={`option-card ${bookingValues?.deliveryAmount === "Yes" ? 'selected' : ''}`}
                  onClick={() => handleRadioChange("Yes")}
                >
                  <div style={{ pointerEvents: 'none' }}>
                    <CustomRadio
                      onChange={() => { }}
                      checked={bookingValues?.deliveryAmount === "Yes"}
                      label=""
                    />
                  </div>
                  <div className="option-content">
                    <div className="radio-label-noninsurence">Pickup by myself</div>
                  </div>
                </div>

                <div
                  className={`option-card ${bookingValues?.deliveryAmount === "No" ? 'selected' : ''}`}
                  onClick={() => handleRadioChange("No")}
                >
                  <div style={{ pointerEvents: 'none' }}>
                    <CustomRadio
                      onChange={() => { }}
                      checked={bookingValues?.deliveryAmount === "No"}
                      label=""
                    />
                  </div>
                  <div className="option-content">
                    <div className="radio-label-noninsurence">Deliver to me</div>
                  </div>
                </div>
              </div>

              {deliveryOptionError && (
                <div className="text-danger mt-2 fw-bold">{deliveryOptionError}</div>
              )}
            </div>

            {/* Nearest Branch Section (Pickup) */}
            {bookingValues?.deliveryAmount === "Yes" && availableMerchants.length > 0 && (
              <div className="mb-5 select-branch-section">
                <div className="d-flex align-items-center gap-2 mb-4">
                  <div className="section-header-bar"></div>
                  <h2 className="page-head-add fs-5 mb-0">Select Branch</h2>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <div className="contactinfo_text_label">Nearest Branches <span className="text-danger">*</span></div>
                    <div className="custom-dropdown-wrapper" ref={dropdownRef}>
                      <div
                        className={`bagroundcolor ${isDropdownOpen ? 'active' : ''}`}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        {selectedMerchantId
                          ? availableMerchants.find(m => m.merchant_id === selectedMerchantId)?.shop_name
                          : "Select Merchant"
                        }
                      </div>

                      {isDropdownOpen && createPortal(
                        <div className="custom-dropdown-portal-container">
                          <div className="dropdown-backdrop" onClick={() => setIsDropdownOpen(false)}></div>
                          <div
                            className="custom-dropdown-list"
                            style={{
                              top: dropdownPos.top + 5,
                              left: dropdownPos.left,
                              width: dropdownPos.width,
                              position: 'absolute'
                            }}
                          >
                            <div
                              className="dropdown-item merchant-name"
                              onClick={() => handleMerchantSelection("")}
                            >
                              Select Merchant
                            </div>
                            {availableMerchants.map((merchant) => (
                              <div
                                key={merchant.merchant_id}
                                className={`dropdown-item ${selectedMerchantId === merchant.merchant_id ? 'selected' : ''}`}
                                onClick={() => handleMerchantSelection(merchant.merchant_id)}
                              >
                                <div className="merchant-name">{merchant.shop_name}</div>
                                <div className="merchant-address">
                                  {merchant.shop_address?.address}, {merchant.shop_address?.state}, {merchant.shop_address?.country}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>,
                        document.body
                      )}
                    </div>
                    {nearestBranchError && (
                      <div className="text-danger mt-2 fw-bold">{nearestBranchError}</div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Return Section (Deliver) */}
            {bookingValues?.deliveryAmount === "No" && (
              <div className="mb-5">
                <div className="d-flex align-items-center gap-2 mb-4">
                  <div className="section-header-bar"></div>
                  <h2 className="page-head-add fs-5 mb-0">How would you prefer to receive the car?</h2>
                </div>

                <div className="options-grid">
                  <div
                    className={`option-card ${returnOption === "dropoff" ? 'selected' : ''}`}
                    onClick={() => {
                      setReturnOption("dropoff");
                      mutation.mutate();
                    }}
                  >
                    <div style={{ pointerEvents: 'none' }}>
                      <CustomRadio
                        onChange={() => { }}
                        checked={returnOption === "dropoff"}
                        label=""
                      />
                    </div>
                    <div className="option-content">
                      <div className="radio-label-noninsurence">Drop off by myself</div>
                    </div>
                  </div>

                  <div
                    className={`option-card ${returnOption === "collect" ? 'selected' : ''}`}
                    onClick={() => {
                      setReturnOption("collect");
                      mutation.mutate();
                    }}
                  >
                    <div style={{ pointerEvents: 'none' }}>
                      <CustomRadio
                        onChange={() => { }}
                        checked={returnOption === "collect"}
                        label=""
                      />
                    </div>
                    <div className="option-content">
                      <div className="radio-label-noninsurence">Collect from me</div>
                    </div>
                  </div>
                </div>

                {/* Airport Options */}
                {showAirportOptions && (
                  <div className="mt-5 pt-4 border-top border-theme-dark">
                    <div className="d-flex align-items-center gap-2 mb-4">
                      <div className="section-header-bar"></div>
                      <h2 className="page-head-add fs-5 mb-0">Is the Pickup Location at the Airport?</h2>
                    </div>

                    <div className="options-grid">
                      {!showAirportError && (
                        <div
                          className={`option-card ${bookingValues?.isAirport === true ? 'selected' : ''}`}
                          onClick={() => handleAirportPickupChange("Yes")}
                        >
                          <div style={{ pointerEvents: 'none' }}>
                            <CustomRadio
                              onChange={() => { }}
                              checked={bookingValues?.isAirport === true}
                              label=""
                            />
                          </div>
                          <div className="option-content">
                            <div className="radio-label-noninsurence">Yes</div>
                          </div>
                        </div>
                      )}

                      <div
                        className={`option-card ${bookingValues?.isAirport === false ? 'selected' : ''}`}
                        onClick={() => handleAirportPickupChange("No")}
                      >
                        <div style={{ pointerEvents: 'none' }}>
                          <CustomRadio
                            onChange={() => { }}
                            checked={bookingValues?.isAirport === false}
                            label=""
                          />
                        </div>
                        <div className="option-content">
                          <div className="radio-label-noninsurence">No</div>
                        </div>
                      </div>
                    </div>
                    {showAirportError && (
                      <div className="text-danger mt-3 fw-bold small">
                        No delivery available for this merchant inside the airport
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Desktop Actions */}
            <div className="vehicle-inspection-actions">
              <button className="btn all_button_style order-back_button_outline" onClick={handleBack}>BACK</button>
              <button className="btn all_button_style confirm-btn" onClick={handleConfirmation}>CONFIRM</button>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar Summary */}
      <div className="col-lg-4 vehicle-inspection-summary-section pb-5">
        <div className="sticky-sidebar">
          <RentalSummarySecondPage
            daysDifference={deliveryDetails.daysDifference}
            totalAmount={deliveryDetails.totalAmount}
            childSeatAmount={babySeatAmount}
            onDataFromRentalSummary={(data: any) => {
              console.log("Data from Rental Summary:", data);
            }}
            paiInsuranceAmount={pai_InsuranceAmount}
            carImage={selectedItem?.product_details?.images?.[0]}
            carModel={selectedItem?.product_details_car?.car_model}
            seat={selectedItem?.product_details_car?.number_of_seats}
            fuelType={selectedItem?.product_details_car?.fuel_type}
            airportFee={bookingValues?.airportFee || 0}
            wtpAmount={wtpAmount}
            cdwAmount={cdw_Amount}
            scdwAmount={scdw_Amount}
            deliveryFee={deliveryFee}
            rentalTotalVat={rentalTotalVat}
            rentalTotalStripeFeeFinal={rentalTotalStripeFeeFinal}
            merchantId={merchantId1 || merchantId}
            additionalDriverFee={additionalDriverFee || 0}
            isLastPage={false}
          />
        </div>
      </div>

      {/* Mobile Sticky Buttons */}
      <div className="vehicle-inspection-button-mobile">
        <button className="btn all_button_style order-back_button_outline" onClick={handleBack}>BACK</button>
        <button className="btn all_button_style confirm-btn" onClick={handleConfirmation}>CONFIRM</button>
      </div>
    </div>
  );
};

export default VehicleInspection;
